// import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
// import React, { useEffect, useState } from "react";

// import { Dialog } from "@headlessui/react";
// import { TfiDownload } from "react-icons/tfi";
// import { saveAs } from "file-saver";

// function Navbar() {
// 	const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
// 	const [hasScrolled, setHasScrolled] = useState(false);
// 	const handleMenuItemClick = () => {
// 		setMobileMenuOpen(false);
// 	};
// 	const handleSaveFiles = () => {
// 		const cvFileUrl =
// 			"https://docs.google.com/document/d/1nKTYS6Kpbudj4OrKxVRiX51Bv75g_WiLrREEeJjCEqQ/edit?usp=sharing";
// 		saveAs(cvFileUrl, "Martins Akhivbareme's Resume.pdf");

// 		// const coverLetterFileUrl =
// 		// 	"https://drive.google.com/file/d/1z9DWkaq3lZL6qscMG2YZ1c6Vf_8btaKC/view?usp=share_link";
// 		// saveAs(coverLetterFileUrl, "CoverLetter.pdf");
// 	};

// 	useEffect(() => {
// 		function handleScroll() {
// 			if (window.pageYOffset > 0) {
// 				setHasScrolled(true);
// 			} else {
// 				setHasScrolled(false);
// 			}
// 		}

// 		window.addEventListener("scroll", handleScroll);

// 		return () => {
// 			window.removeEventListener("scroll", handleScroll);
// 		};
// 	}, []);

// 	const navigation = [
// 		{ name: "About", href: "#Hero" },
// 		{ name: "Services", href: "#Services" },
// 		{ name: "Portfolio", href: "#Portfolio" },
// 		{ name: "Testimonials", href: "#Testimonials" },
// 		{ name: "Contact", href: "#Contact" },
// 	];

// 	return (
// 		<div
// 			className={`isolate fixed w-full z-10 ${
// 				hasScrolled && "bg-transparent"
// 			}`}>
// 			<div className='px-10 p-5 lg:px-24 border-b-2 border-gray-900'>
// 				<nav className='flex items-center justify-between' aria-label='Global'>
// 					<div className='flex lg:flex-1'>
// 						<a href='/' className='m-1.5 p-1.5'>
// 							<span className='sr-only'>Martins</span>
// 							<span className='text-xl font-bold text-gray-900 hover:text-indigo-500'>
// 								Martins
// 							</span>
// 						</a>
// 					</div>
// 					<div className='flex lg:hidden'>
// 						<button
// 							type='button'
// 							className='-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700 hover:text-indigo-500'
// 							onClick={() => setMobileMenuOpen(true)}>
// 							<span className='sr-only'>Open menu</span>
// 							<Bars3Icon className='h-6 w-6' aria-hidden='true' />
// 						</button>
// 					</div>
// 					<div className='hidden lg:flex lg:gap-x-12'>
// 						{navigation.map((item) => (
// 							<a
// 								key={item.name}
// 								href={item.href}
// 								className='text-base font-semibold leading-6 text-gray-900 hover:text-indigo-500'
// 								onClick={handleMenuItemClick}>
// 								{item.name}
// 							</a>
// 						))}
// 					</div>

// 					<div className='hidden lg:flex lg:flex-1 lg:justify-end bg-cover'>
// 						<button
// 							className='flex justify-center gap-2 border-2 border-gray-900 bg-transparent px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-900 hover:border-gray-600 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
// 							onClick={() =>
// 								window.open(
// 									"https://docs.google.com/document/d/1nKTYS6Kpbudj4OrKxVRiX51Bv75g_WiLrREEeJjCEqQ/edit?usp=sharing",
// 									"_blank"
// 								)
// 							}>
// 							Download CV{""}
// 							<span aria-hidden='true' className='mt-1'>
// 								<TfiDownload size={12} />
// 							</span>
// 						</button>
// 					</div>
// 				</nav>
// 				<Dialog as='div' open={mobileMenuOpen} onClose={setMobileMenuOpen}>
// 					<Dialog.Panel className='fixed inset-0 z-10 overflow-y-auto bg-white px-6 py-6 lg:hidden'>
// 						<div className='flex items-center justify-between'>
// 							<a href='#!' className='-m-1.5 p-1.5'>
// 								<span className='sr-only'>Martins</span>
// 								<span className='text-xl font-bold text-gray-900 hover:text-indigo-500'>
// 									Martins
// 								</span>
// 							</a>
// 							<button
// 								type='button'
// 								className='-m-2.5 rounded-md p-2.5 text-gray-700 hover:text-indigo-500'
// 								onClick={() => setMobileMenuOpen(false)}>
// 								<span className='sr-only'>Close menu</span>
// 								<XMarkIcon className='h-6 w-6' aria-hidden='true' />
// 							</button>
// 						</div>
// 						<div className='mt-6 flow-root'>
// 							<div className='-my-6 divide-y divide-gray-500/10'>
// 								<div className='space-y-2 py-6'>
// 									{navigation.map((item) => (
// 										<a
// 											key={item.name}
// 											href={item.href}
// 											className='-mx-3 block rounded-lg py-2 px-3 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-400/10 hover:text-indigo-500'
// 											onClick={handleMenuItemClick}>
// 											{item.name}
// 										</a>
// 									))}
// 								</div>
// 								<div className='py-6'>
// 									<button
// 										taget
// 										className='-mx-3 block rounded-lg py-2.5 px-3 text-base font-semibold leading-6 text-gray-900 hover:bg-gray-400/10 hover:text-indigo-500'
// 										onClick={() => {
// 											handleSaveFiles();
// 											handleMenuItemClick();
// 										}}>
// 										Download CV
// 									</button>
// 								</div>
// 							</div>
// 						</div>
// 					</Dialog.Panel>
// 				</Dialog>
// 			</div>
// 		</div>
// 	);
// }

// export default Navbar;

import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";

import { Dialog } from "@headlessui/react";
import { TfiDownload } from "react-icons/tfi";
import { saveAs } from "file-saver";

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  const handleMenuItemClick = () => {
    setMobileMenuOpen(false);
  };

  const handleSaveFiles = () => {
    const cvFileUrl =
      "https://docs.google.com/document/d/1nKTYS6Kpbudj4OrKxVRiX51Bv75g_WiLrREEeJjCEqQ/edit?usp=sharing";
    saveAs(cvFileUrl, "Martins Akhivbareme's Resume.pdf");
  };

  useEffect(() => {
    function handleScroll() {
      if (window.scrollY > 0) {
        setHasScrolled(true);
      } else {
        setHasScrolled(false);
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navigation = [
    { name: "About", href: "#Hero" },
    { name: "Services", href: "#Services" },
    { name: "Portfolio", href: "#Portfolio" },
    { name: "Testimonials", href: "#Testimonials" },
    { name: "Contact", href: "#Contact" },
  ];

  return (
    <div className={`isolate fixed w-full z-10 ${hasScrolled ? "bg-white" : "bg-transparent"}`}>
      <div className="px-10 p-5 lg:px-24 border-b-2 border-gray-900">
        <nav className="flex items-center justify-between" aria-label="Global">
          <div className="flex lg:flex-1">
            <a href="/" className="m-1.5 p-1.5">
              <span className="sr-only">Martins</span>
              <span className="text-xl font-bold text-gray-900 hover:text-indigo-500">Martins</span>
            </a>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700 hover:text-indigo-500"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-12">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-base font-semibold leading-6 text-gray-900 hover:text-indigo-500"
                onClick={handleMenuItemClick}
              >
                {item.name}
              </a>
            ))}
          </div>

          <div className="hidden lg:flex lg:flex-1 lg:justify-end bg-cover">
            <button
              className="flex justify-center gap-2 border-2 border-gray-900 bg-transparent px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-900 hover:border-gray-600 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={() =>
                window.open(
                  "https://docs.google.com/document/d/1nKTYS6Kpbudj4OrKxVRiX51Bv75g_WiLrREEeJjCEqQ/edit?usp=sharing",
                  "_blank"
                )
              }
            >
              Download CV{""}
              <span aria-hidden="true" className="mt-1">
                <TfiDownload size={12} />
              </span>
            </button>
          </div>
        </nav>
        <Dialog as="div" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
          <Dialog.Panel className="fixed inset-0 z-10 overflow-y-auto bg-white px-6 py-6 lg:hidden">
            <div className="flex items-center justify-between">
              <a href="#!" className="-m-1.5 p-1.5">
                <span className="sr-only">Martins</span>
                <span className="text-xl font-bold text-gray-900 hover:text-indigo-500">Martins</span>
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700 hover:text-indigo-500"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      className="-mx-3 block rounded-lg py-2 px-3 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-400/10 hover:text-indigo-500"
                      onClick={handleMenuItemClick}
                    >
                      {item.name}
                    </a>
                  ))}
                </div>
                <div className="py-6">
                  <button
                    taget
                    className="-mx-3 block rounded-lg py-2.5 px-3 text-base font-semibold leading-6 text-gray-900 hover:bg-gray-400/10 hover:text-indigo-500"
                    onClick={() => {
                      handleSaveFiles();
                      handleMenuItemClick();
                    }}
                  >
                    Download CV
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Panel>
        </Dialog>
      </div>
    </div>
  );
}

export default Navbar;

